import { render, staticRenderFns } from "./ManageRolePermission.vue?vue&type=template&id=12bcb2a6"
import script from "./ManageRolePermission.vue?vue&type=script&lang=js"
export * from "./ManageRolePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports